import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=3580a578&scoped=true"
import script from "./tagList.vue?vue&type=script&lang=js"
export * from "./tagList.vue?vue&type=script&lang=js"
import style0 from "./tagList.vue?vue&type=style&index=0&id=3580a578&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580a578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3580a578')) {
      api.createRecord('3580a578', component.options)
    } else {
      api.reload('3580a578', component.options)
    }
    module.hot.accept("./tagList.vue?vue&type=template&id=3580a578&scoped=true", function () {
      api.rerender('3580a578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tagList.vue"
export default component.exports